export default __webpack_public_path__ + "static/media/Mark-4-Suit-03.b9f64c1b.jpg";